import React from 'react'

const About = () => {
  return (
    <section id='services'>
      <div className="container brd-white bottom-none p-5">
        <h2 className="title-intro c-white">Services</h2>
        <div className="s-50"></div>
        <div className="row">
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Outsource</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Outstaff</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Dedicated Teams</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export { About }
